import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { AiProviderModels } from "types/generated";

import { GET_AVAILABLE_AI_MODELS } from "./gql";

type UseAvailableAiModelsReturn = {
  allProviderModels: AiProviderModels[];
  loading: boolean;
  error: Error | undefined;
};

const useAvailableAiModels = (provider?: string): UseAvailableAiModelsReturn => {
  const { data, loading, error } = useQuery(GET_AVAILABLE_AI_MODELS, {
    variables: { provider: provider ?? null },
  });

  const allProviderModels = useMemo(() => {
    return data?.availableAIModels || [];
  }, [data]);

  return {
    allProviderModels,
    loading,
    error,
  };
};

export default useAvailableAiModels;
